<template>
  <div>
    <choose-place :modal="'choose-place'" :item="item"/>
    <language-list
      v-if="isLang === true"
      v-model="langCurrent"
      :name="`${item.id}${name ? name : ''}`"
    />
    <div class="row">
      <template v-for="field in fields">
        
        <div
          :class="[
            {'col-lg-5': field.key == 'lon' || field.key == 'lat'},
            field.col ? field.col : 'col-12' 
          ]"
          
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-if="
            field.ishide !== true &&
            field.type === 'field' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
        <!-- <div v-if="field.key == 'prices'">
          {{ item[field.key] }}
            {{ item[field.key].items }}
            <fg-input
              v-for="(sfield, key) in field.items" :key="key"
              :type="sfield.textType"
              :label="sfield.label"
              v-model="item[sfield.key]"
              :readonly="sfield.readonly"
              step="1"
            >
            </fg-input>
          </div> -->
            <fg-input
              :type="field.textType"
              :label="field.label"
              v-model="item[field.key]"
              :readonly="field.readonly"
              step="1"
            ></fg-input>
        </div>
        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-if="
            field.ishide !== true &&
            field.type === 'mask' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <fg-input
            type="text"
            :label="field.label"
            v-mask="field.mask"
            v-model="item[field.key]"
          />
        </div>

        
        <div v-if="field.key == 'lon'" :key="field.key+'-btn'" class="col-12 col-md-2 d-flex align-items-center">
          <p-button 
            @click.native.prevent="$modal.show('choose-place', {lang: langCurrent})" 
            type="default"
            size="sm"
            class="d-flex align-items-center"
            >
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" width="30" enable-background="new 0 0 512 512" viewBox="0 0 512 512"><path d="M315.39,170.87c0-32.188-26.193-58.375-58.39-58.375s-58.39,26.187-58.39,58.375  c0,32.196,26.193,58.39,58.39,58.39S315.39,203.066,315.39,170.87z M218.61,170.87c0-21.16,17.222-38.375,38.39-38.375  s38.39,17.215,38.39,38.375c0,21.168-17.222,38.39-38.39,38.39S218.61,192.038,218.61,170.87z M455.269,446.795l-64.921-170.047  c-1.479-3.875-5.196-6.434-9.343-6.434l-37.366,0c19.638-32.509,35.184-67.03,35.184-94.857c0-67.172-54.649-121.82-121.822-121.82  c-24.002,0-47.232,6.982-67.18,20.19c-4.604,3.05-5.865,9.254-2.816,13.858c3.05,4.605,9.255,5.865,13.859,2.817  C217.525,79.469,236.937,73.637,257,73.637c56.145,0,101.822,45.676,101.822,101.82c0,26.886-18.657,67.491-53.955,117.424  c-18.727,26.491-37.649,49.163-47.766,60.875c-34.141-40.608-101.924-131.001-101.924-178.298c0-21.132,6.413-41.397,18.547-58.604  c3.183-4.513,2.104-10.752-2.41-13.935c-4.513-3.184-10.752-2.104-13.936,2.41c-14.524,20.597-22.201,44.847-22.201,70.129  c0,23.396,12.257,55.22,36.474,94.857h-38.656c-4.146,0-7.863,2.559-9.343,6.433l-64.92,170.048  c-1.174,3.074-0.761,6.528,1.105,9.238s4.946,4.329,8.236,4.329l279.994-0.001c5.522,0,10-4.477,10-10c0-5.522-4.478-10-10-10  H295.93l106.968-74.668l28.507,74.668h-41.838c-5.522,0-10,4.478-10,10c0,5.523,4.478,10,10,10h56.359  c3.29,0,6.37-1.618,8.236-4.329C456.028,453.324,456.441,449.87,455.269,446.795z M139.881,290.315h44.563  c2.707,4.061,5.512,8.185,8.439,12.388c0.823,1.181,1.645,2.354,2.466,3.519l-84.131,59.169L139.881,290.315z M98.457,398.818  l60.115-42.279l47.868,83.824l-123.845,0L98.457,398.818z M264.389,375.74c1.778-2.017,19.428-21.435,40.315-48.808l32.762,60.046  l-76.478,53.384l-31.517,0l-54.468-95.38l32.063-22.549c22.406,30.273,41.456,52.068,42.415,53.161c0,0,2.772,3.157,6.646,3.364  C256.127,378.959,260.944,379.647,264.389,375.74z M353.965,375.461l-36.141-66.238c4.371-6.086,8.77-12.415,13.097-18.908l43.198,0  l21.426,56.122L353.965,375.461z"/></svg>
          </p-button>
        </div>


        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-if="
            field.ishide !== true &&
            field.type === 'tag' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <label>{{ field.label }}</label>
          <tags v-model="item[field.key]" />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'img' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <img-upload
            :name="field.key"
            v-model="item[field.key]"
            :title="field.label"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'imgs' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <images
            :url="field.image_key"
            v-model="item[field.key]"
            :title="field.label"
            :result="item[field.resultKey]"
            :link="field.link"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'zip' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <zip-upload
            v-model="item[field.key]"
            :title="field.label"
            :name="field.key"
            :result="item[field.resultKey]"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'select' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <selector
            :disabled="field.readonly"
            v-model="item[field.key]"
            :title="field.label"
            :prefix="field.prefix"
            :modal="field.modal"
            :input="field.input"
            :params="field.params"
            :selectKey="field.selectKey"
            @input="conditional"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          class="mb-3"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.type === 'selectlist' 
          "
          :key="field.key"
        >
          <label>{{ field.label }}</label>
          <select v-model="item[field.key]" class="form-control">
            <option v-for="(el, key) in field.values" :value="key+1" :key="key+1">{{el.title}}</option>
          </select>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'selects' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <selectors
            :disabled="field.readonly"
            :selectKey="field.selectKey"
            v-model="item[field.key]"
            :title="field.label"
            :modal="field.modal"
            :prefix="field.prefix"
            :params="field.params"
            :input="field.input"
            @input="conditional"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          class="mb-3"

          v-else-if="
            field.type == 'daystable' 
          "
          :key="field.key"
        >
          <label>{{ field.label }}</label>
          <div class="selectdays mb-3">
            <div class="selectdays__items" v-for="week in 5" :key="week">
              <div class="selectdays__item">{{week}} неделя</div>
              <div class="selectdays__item" 
                v-for="(day, key) in ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']" 
                :key="key"
                :class="{'active': item[field.key] ? item[field.key].some(e=>{return e == `${week}-${key+1}`}) : false}">
                <label>
                  <input type="checkbox" :name="`wd`" @change="selectdayChange(field.key, `${week}-${key+1}`)">
                  <span>{{ day }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'datetime' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <label>{{ field.label }}</label>
          <datetime
            class="from-control"
            type="datetime"
            v-model="item[field.key]"
            format="dd/MM/yyyy HH:mm:ss"
          ></datetime>
        </div>

        <div
          class="m-y-2 m-b-4"
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'checkbox' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          
          <checkbox v-model="item[field.key]">{{
            field.label
          }}</checkbox>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'static_radio' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <radio-list
            :title="field.label"
            :items="field.items"
            :name="field.key"
            v-model="item[field.key]"
            color="#ffc107"
            >{{ field.label }}</radio-list
          >
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'object' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <h4>{{ field.label }}</h4>
          <sub-field-list
            v-model="item[field.key]"
            :subFields="field.subFields"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'location' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <label>{{ field.label }}</label>

          <location
            :city="item.location ? item.location.id : null"
            :region="item.location ? item.location.parent_id : null"
            v-model="item[field.key]"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'textarea' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <div class="form-group">
            <label class="control-label">{{ field.label }}</label>
            <textarea class="form-control" v-model="item[field.key]" />
          </div>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'role' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <div class="form-group">
            <label class="control-label">{{ field.label }}</label>
            <role v-model="item[field.key]" />
          </div>
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-else-if="
            field.ishide !== true &&
            field.type === 'html' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <div
            v-show="
              !field.langKey || (field.langKey && field.langKey === langCurrent)
            "
          >
            <label class="control-label">{{ field.label }}</label>

            <quill-editor v-model="item[field.key]" :options="editorOption" />
            <br />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
/**Меняю добавление модалку */
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "FieldsList",
  data: () => ({
    langCurrent: "ru",
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "image"], // toggled buttons
          ["blockquote", "code-block"],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
        ],
      },
    },
  }),
  components: {
    quillEditor,
    "choose-place": () => import("../Modals/ChoosePlace"),
  },
  props: ["item", "fields", "name"],
  computed: {
    isLang: {
      get() {
        for (let i = 0; i < this.fields.length; i++) {
          if (this.fields[i].isMultiLang) {
            return true;
          }
        }
        return false;
      },
    },
  },
  created() {
    // Object.keys(this.item).indexOf('visiting_days')
    // if(!this.item.visiting_days.length)
    //   this.item.visiting_days = []
    if(this.item.visiting_days)
      this.item.visiting_days = this.item.visiting_days.map(element => {
        return `${element['week']}-${element['day']}`
      });
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type === "hidden") {
        this.item[this.fields[i].key] = this.fields[i].value;
      }
    }
  },
  methods: {
    selectdayChange(model, str){
      if(!this.item[model])
        this.item[model] = []
      if(this.item[model] && this.item[model].indexOf(str) >=0 )
        this.item[model].splice(this.item[model].indexOf(str), 1)
      else
        this.item[model].push(str)
    },
    conditional(val) {
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].toParametr) {
          if (
            this.fields[i].toParametr.key &&
            this.fields[i].toParametr.parametr
          ) {
            let key = this.fields[i].toParametr.key;
            let parametr = this.fields[i].toParametr.parametr;
            for (let j = 0; j < this.fields.length; j++) {
              if (this.fields[j].key === key) {
                let value = null;
                if (val && val.id) {
                  value = val.id;
                }
                this.fields[j].params[parametr] = value;
                //Как мне узнать, актуальную выборку
                //this.item[key]  = null;
              }
            }
          }
        }
      }
    },
  },
};
</script>

